import React from 'react';
import { useTranslation } from 'react-i18next';

import AppButton from 'components/AppButton';

type NFTGroupButtonProps = {
  isSubmit: boolean;
  onDiscard: () => void;
  id?: string;
};

const NFTGroupButton = ({ isSubmit, onDiscard, id }: NFTGroupButtonProps) => {
  const { t } = useTranslation();

  return (
    <div className="nft-creation-page-group-button">
      <AppButton text={t('nft_creation.txt_discard')} onClick={onDiscard} disabled={isSubmit} />
      <AppButton
        text={id ? t('nft_creation.txt_save_changes') : t('nft_creation.txt_create_item')}
        htmlType="submit"
        disabled={isSubmit}
        loading={isSubmit}
        variant="primary"
      />
    </div>
  );
};

export default NFTGroupButton;
